import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSafe } from '../../../shared/utility';
import * as STATE_PATHS from '../../../shared/const/Routes/statePaths';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import './Modal.scss';

const ESCAPE_KEY_EVENT = 27;
const CLICK_EVENT_TARGET = 'modal';

const Modal = props => {
  const close = useCallback(() => onCancel(), []);

  const handleEscape = useCallback(event => {
    if (event.keyCode == ESCAPE_KEY_EVENT) close();
  }, []);

  const handleClick = useCallback(event => {
    if (event.target.id == CLICK_EVENT_TARGET) close();
  }, []);
  const {
    visible = false,
    className = 'modal',
    title,
    cancelText = 'Cancel',
    okText = 'Ok',
    okType = 'primary',
    centered = false,
    closable = true,
    onCancel = close,
    onOk = close,
    footer,
    keyboard = true,
    mask = true,
    maskClosable = true,
    width = 520,
    jobId,
  } = props;
  const externalWindows = useSelector(state =>
    getSafe(STATE_PATHS.EXTERNAL_WINDOWS, state)
  );
  const doc = externalWindows[jobId]
    ? externalWindows[jobId].document
    : document;

  useEffect(() => {
    if (visible) {
      if (keyboard) doc.addEventListener('keydown', handleEscape, false);
      if (maskClosable) doc.addEventListener('click', handleClick, false);
    }
    return () => {
      doc.removeEventListener('keydown', handleEscape, false);
      doc.removeEventListener('click', handleClick, false);
    };
  }, [handleEscape, handleClick, visible]);

  const getCloseButton = () => {
    if (closable) {
      return <CloseCircleOutlined className="ModalIcon" onClick={close} />;
    }
  };

  const getTitle = () => {
    if (title) {
      return <div className="modal-title">{title}</div>;
    }
  };

  const getFooter = () => {
    if (!footer) {
      return (
        <div className="modal-footer">
          <Button key={cancelText} onClick={onCancel}>
            {cancelText}
          </Button>
          <Button key={okText} type={okType} onClick={onOk}>
            {okText}
          </Button>
        </div>
      );
    } else {
      return (
        <div className="modal-footer">{React.Children.toArray(footer)}</div>
      );
    }
  };

  return visible ? (
    <div
      id="modal"
      className={mask ? `${className} ${className}-mask` : className}
    >
      <div
        id="modal-content"
        className="modal-content"
        style={{ width: `${width}px` }}
      >
        {getCloseButton()}
        <div className="modal-header">{getTitle()}</div>
        <div className="modal-body">{props.children}</div>
        {getFooter()}
      </div>
    </div>
  ) : null;
};

export default Modal;
